<template>
  <div class="modal-overlay" @click.self="handleClose">
    <div class="modal-content">
      <div class="modal-header">
        <h2>加入资源</h2>
        <button class="btn-close" @click="handleClose">×</button>
      </div>
      
      <form class="add-form" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>资源标题：</label>
          <input 
            type="text" 
            v-model="form.title" 
            placeholder="请输入资源标题"
            required
          />
        </div>
        
        <div class="form-group">
          <label>资源分类：</label>
          <select v-model="form.category">
            <option value="服务">服务</option>
            <option value="技术">技术</option>
            <option value="农业">农业</option>
            <option value="物流">物流</option>
            <option value="应急">应急</option>
            <option value="环保">环保</option>
            <option value="能源">能源</option>
            <option value="其他">其他</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>描述：</label>
          <textarea 
            v-model="form.description" 
            placeholder="请输入详细描述"
            rows="4"
            required
          />
        </div>
        
        <div class="form-group">
          <label>公司名称：</label>
          <input 
            type="text" 
            v-model="form.company" 
            placeholder="请输入公司名称"
            required
          />
        </div>
        
        <div class="form-group">
          <label>联系人昵称：</label>
          <input 
            type="text" 
            v-model="form.nickname" 
            placeholder="请输入联系人昵称"
            required
          />
        </div>
        
        <div class="form-group">
          <label>所在地点：</label>
          <input 
            type="text" 
            v-model="form.location" 
            placeholder="例如：北京市朝阳区"
            required
          />
        </div>
        
        <div class="form-group">
          <label>联系电话：</label>
          <input 
            type="text" 
            v-model="form.phone" 
            placeholder="请输入联系电话"
            required
          />
        </div>
        
        <div class="form-group">
          <label>标签（用逗号分隔）：</label>
          <input 
            type="text" 
            v-model="form.tags" 
            placeholder="例如：航拍,摄影,视频"
          />
        </div>
        
        <div class="form-group">
          <label>图片URL（可选）：</label>
          <input 
            type="text" 
            v-model="form.image" 
            placeholder="请输入图片URL，不填则使用默认图片"
          />
        </div>
        
        <div class="form-actions">
          <button type="button" class="btn-cancel" @click="handleClose">取消</button>
          <button type="submit" class="btn-submit">加入</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddResourceModal',
  data() {
    return {
      form: {
        title: '',
        description: '',
        category: '服务',
        company: '',
        nickname: '',
        location: '',
        phone: '',
        tags: '',
        image: ''
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      const newResource = {
        id: Date.now(),
        title: this.form.title,
        description: this.form.description,
        category: this.form.category,
        company: this.form.company,
        nickname: this.form.nickname,
        location: this.form.location,
        phone: this.form.phone,
        tags: this.form.tags ? this.form.tags.split(',').map(tag => tag.trim()) : [],
        image: this.form.image || 'https://images.pexels.com/photos/116775/pexels-photo-116775.jpeg'
      }
      this.$emit('submit', newResource)
      this.form = {
        title: '',
        description: '',
        category: '服务',
        company: '',
        nickname: '',
        location: '',
        phone: '',
        tags: '',
        image: ''
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.btn-close:hover {
  color: #333;
}

.add-form {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #42b983;
}

.form-group textarea {
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-cancel,
.btn-submit {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-cancel {
  background: #f5f5f5;
  border: 1px solid #ddd;
  color: #666;
}

.btn-cancel:hover {
  background: #eee;
}

.btn-submit {
  background: linear-gradient(135deg, #42b983 0%, #35495e 100%);
  border: none;
  color: #fff;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .modal-header,
  .add-form {
    padding: 16px;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-cancel,
  .btn-submit {
    width: 100%;
  }
}
</style>
